<template>
  <div class="content">
    <div class="new-modal-error-icon">!</div>
    <h1>{{ translations.recipeValidationTitle }}</h1>
    <p>{{ translations.recipeValidationDetail }}</p>
  </div>
</template>

<script>
import selectSwatch from '@/mixins/Customizer/SelectSwatch';

const defaultSwatchId = 4;

export default {
  name: 'RecipeValidationModal',

  mixins: [
    selectSwatch,
  ],

  computed: {
    translations(){
      return this.$store.state.translations.data;
    },
    invalidUGCComponents() {
      return this.$store.state.recipe.invalidUGCComponents;
    },
  },

  watch: {
    invalidUGCComponents() {
      this.selectInvalidUGCComponent();
    },
  },

  methods: {
    /**
     * @function startOver
     * Method to be called from parent component from CTA button.
     */
    startOver() {
      if (this.$store.getters['utils/canvasActive']) {
        this.$iframeCommunicator.postMessage({ command: 'startOver' });
      } else {
        window.location = window.location.href;
      }
    },

    /**
     * @function resetComponent
     * Method that resets the active component to the default swatch
     */
    resetComponent() {
      const defaultSwatch = this.$store.state.utils.availableSwatches.find(swatch => Number(swatch.id) === defaultSwatchId);
      this.selectSwatch(defaultSwatch);
      this.$modal.hide('recipeValidationModal');
    },

    /**
     * @function selectInvalidUGCComponent
     * Selects the first component with UGC validation error in the navigation.
     */
    selectInvalidUGCComponent() {
      if (this.invalidUGCComponents.length > 0) {
        this.$eventBus.$emit('select-component', this.invalidUGCComponents[0]);
        this.$modal.show('recipeValidationModal');
      }
    },
  },
  created() {
    this.selectInvalidUGCComponent();
  },
}
</script>